// Shared bits for the board. Rule kinds and their parameters are NOT listed here on purpose — they
// come from the server so a new kind needs no change in this app.

export const SNOOZE_OPTIONS = [
  { days: 1, label: 'Tomorrow' },
  { days: 3, label: 'In 3 days' },
  { days: 7, label: 'In a week' },
];

/** Priorities for hand-written tasks — the one thing on the board staff author rather than query. */
export const PRIORITIES = [
  { key: 'Urgent', label: 'Urgent' },
  { key: 'High', label: 'High' },
  { key: 'Normal', label: 'Normal' },
  { key: 'Low', label: 'Low' },
];

/**
 * The single rule kind whose rows are typed in rather than derived, so it is the only column that
 * offers an "add" button. Everything else about a column stays server-declared.
 */
export const MANUAL_TASKS_KIND = 'ManualTasks';
